export default {"src":"/_next/static/media/recommended-tag-web.5e5440b2.svg","height":32,"width":114,"blurWidth":0,"blurHeight":0};